module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n        Key Information\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "66%"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm.gender))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DOB")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.claimant.dateOfBirth))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age At Date Of Injury/Accident (" + _vm._s(_vm.claim('dateOfInjury')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ageAtInjury))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age At Assumed Settlement (" + _vm._s(_vm.claim('dateOfAssumedSettlement')) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ageAtSettlement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Age Today (" + _vm._s(_vm.today) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ageToday))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width"
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "33%",
      "colspan": "2"
    }
  }, [_vm._v("Pre-Accident Net Income per Annum")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.preAccidentIncome)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total Payments Made")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getPostInjuryIncomePeriodPaymentsTotal)))])]), _vm._v(" "), _vm._l((_vm.pastPeriods), function(period) {
    return (_vm.calcLoss(period) > 0) ? _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "rowspan": "4"
      }
    }, [_vm._v("Period Of Reduced Income")]), _vm._v(" "), _c('td', [_vm._v("Start")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.startOfPeriod))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("End")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.endOfPeriod))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.duration.toFixed(2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Net Income P.A.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.totalNetIncome)))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.futureLosses) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Periods of Future Loss")]), _vm._v(" "), _c('td', [_vm._v("Start")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesStart))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("End")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.futureLossesEnd))])]), _vm._v(" "), (_vm.durationOfPeriod) ? _c('tr', [_c('td', [_vm._v("Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)) + " years")])]) : _vm._e()]) : _vm._e()], 2)]), _vm._v(" "), (_vm.futureLosses) ? _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Pre-Accident")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.disabledAtAccident ? 'Disabled' : 'Not Disabled'))]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n                    Discount Factor: " + _vm._s(_vm.roundValue(_vm.preInjuryDiscountFactor, 2)) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.employedAtAccident ? 'Employed' : 'Not Employed'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.levelOfEducation) + " — Education")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Post-Accident")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.disabledAtAssessment ? 'Disabled' : 'Not Disabled'))]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n                    Discount Factor: " + _vm._s(_vm.roundValue(_vm.assessmentDiscountFactor, 2)) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.employedAtAssessment ? 'Employed' : 'Not Employed'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.levelOfEducation) + " — Education")])])]), _vm._v(" "), _c('tbody', [(_vm.durationOfPeriod) ? _c('tr', [_c('td', [_vm._v("Duration of Future Loss")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.durationOfPeriod.toFixed(2)) + " years")])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Multiplier")]), _vm._v(" "), _c('td', [_vm._v("Ogden Table 36")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.multiplier.toFixed(2)))])])])])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("\n        Heads of Loss\n    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "percentage",
      "label": "Your Percentage of the claim"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "percentage",
      "id": "percentage",
      "max": "100",
      "min": "0",
      "step": "0.1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-bottom-30"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Damages")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getGeneralDamages)))]), _vm._v(" "), (_vm.claim('proceduralStatus') === 'pre-lit') ? _c('td') : _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.otherPastLoss('generalDamagesWithInterest'))) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('generalDamages'))) + "\n                ")])]), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('tr', [_c('td', [_vm._v("Past Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getIncomeValue('pastLossOfEarningsNetTotal'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastLossOfEarnings'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('pastCostOfCare') > 0) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastCostOfCare'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('pastCostOfServices') > 0) ? _c('tr', [_c('td', [_vm._v("Past Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfServices'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfServicesWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastCostOfServices'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('pastCostOfTravel') > 0) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('pastCostOfTravel'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.otherPastLoss('misc') > 0) ? _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('misc'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.otherPastLoss('miscWithInterest'))))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.adjustedForPercent('misc'))) + "\n                ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.allCustomHeadOfLoss), function(headOfLoss) {
    return (_vm.customHeadsOfLossTotal > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(headOfLoss.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(headOfLoss.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(headOfLoss.interestAccrued)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.futurePensionTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Pension")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futurePensionTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('futurePensionTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.futureCareTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureCareTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('futureCareTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.futureServicesTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureServicesTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('futureServicesTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.purchasesTotal > 0) ? _c('tr', [_c('td', [_vm._v("Future Purchases")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.purchasesTotal)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('purchasesTotal'))))])]) : _vm._e(), _vm._v(" "), (_vm.lossResult > 0) ? _c('tr', [_c('td', [_vm._v("Future Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.lossResult)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('lossResult'))))])]) : _vm._e(), _vm._v(" "), (_vm.cruTotalDeductions > 0) ? _c('tr', [_c('td', [_vm._v("CRU Benefits")]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.currencyFormat(_vm.cruTotalDeductions)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('cruTotalDeductions'))))])]) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('subTotal'))))])]), _vm._v(" "), (_vm.getAllInterimPaymentsTotal > 0) ? _c('tr', {
    staticClass: "a-table--penultimate"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.total)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('total'))))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total "), (_vm.getAllInterimPaymentsTotal > 0) ? _c('span', [_vm._v("less interim payment(s)")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalLessInterimPayments)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.adjustedForPercent('totalLessInterimPayments'))))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons flex-state-buttons--block a-table--center"
  }, [_c('div', [_c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'personal::step-8'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'personal::documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                View Documents\n            ")])], 1)]), _vm._v(" "), _c('reserves-for-claim')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("The Claimant")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h2', [_vm._v("Income, Absenses From Work & Any Future Periods of Loss")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h2', [_vm._v("Multipliers & Discount Factors for Contingencies Other Than Mortality")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_c('h2', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_c('h2', [_vm._v("Interest")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_c('h2', [_vm._v("Apportioned Total")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02f0e1c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/CalculateLoss.vue
// module id = 1558
// module chunks = 0